import React, { useContext } from 'react';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import {
  PromptContext,
  TableContext,
  TableSelectedContext,
  TableToolbarButton,
  usePrompts,
} from '@eas/common-web';
import {
  BULK_OPERATION_FORM_KEY_TABLE,
  BulkOperationFormWorkOrderTable,
} from '../calendar/controls/bulk-operations/bulk-operations-form';
import { PlannerContext } from '../planner-context';

export function BulkUnplanSelectedWorkOrders({
  clearCache,
}: {
  clearCache?: () => void;
}) {
  const { selected } = useContext(TableSelectedContext);
  const { source } = useContext(TableContext);
  const { calendarSource, workOrderSource } = useContext(PlannerContext);
  const { testPrompt } = useContext(PromptContext);

  usePrompts(
    [
      {
        key: BULK_OPERATION_FORM_KEY_TABLE,
        dialogTitle: `Aplikovať hromadnú akciu`,
        dialogText: (
          <BulkOperationFormWorkOrderTable
            selected={selected}
            refresh={() => {
              clearCache?.();
              calendarSource?.yAxis?.refreshData();
              workOrderSource?.reset();
              workOrderSource?.loadMore();
            }}
          />
        ),
        dialogWidth: 1200,
        dialogShowConfirm: false,
      },
    ],
    [clearCache, calendarSource, workOrderSource, selected]
  );

  if (selected.length < 1 || !source || source.items.length < 1) {
    return null;
  }

  return (
    <>
      <TableToolbarButton
        tooltip="Aplikovať hromadnú akciu na PP označené v tabulke."
        label={
          <>
            <EventBusyIcon fontSize="small" />{' '}
            <span style={{ marginLeft: 4 }}>Aplikovať hromadnú akciu</span>
          </>
        }
        onClick={async () => {
          testPrompt({
            key: BULK_OPERATION_FORM_KEY_TABLE,
            submitCallback: async () => {},
          });
        }}
      />
    </>
  );
}
